// React.
import { useMemo } from 'react';

// Types.
import { StatisticTimeslice } from '../../../types/instance/Statistic';

// Components.
import EChartsWithData from '../../chart/echarts/EChartsWithData';
import { EChartTimeSeries } from '../../chart/echarts/types';

// Helpers.
import { getConvertedTimeToUTC } from '../../../helpers/utils';

// Constants
import { CHART_DATA_TYPE, TARGET_COLOUR_CODES } from "../../Constants";

const LABELLED_AXIS = [{ labels: true }];

export default function StatisticChart(props: {
    error: string | null,
    loading: boolean, data: StatisticTimeslice[],
    statistic: string, cumulative: boolean, index: number
}) {
    const { error, loading, data, statistic, cumulative, index }
        = props;

    const tooltipType = statistic.includes('time') ? CHART_DATA_TYPE.TIME : CHART_DATA_TYPE.GENERIC;

    const series = useMemo<EChartTimeSeries[]>(() => [{
        name: statistic,
        chartType: 'line',
        smooth: false,
        color: TARGET_COLOUR_CODES[index % TARGET_COLOUR_CODES.length],
        data: data.map((dat: any) => [getConvertedTimeToUTC(dat), dat[cumulative ? 'sum' : 'avg']]),
    }], [data, statistic, cumulative, index]);

    return (
        <div className="card collapsible">
            <div className="card-header">
                <i className="fal fa-chart-bar fa-fw" aria-hidden="true"/>
                {statistic}
                <i className="collapse-toggle" role="button" data-bs-toggle="collapse"
                    data-bs-target={"#collapse-" + index} aria-expanded="false" aria-controls={"collapse-" + index}/>
            </div>
            <div id={"collapse-" + index} className="card-body collapse show" style={{ minHeight: '232px' }}>
                <EChartsWithData error={error} loading={loading} length={data.length}
                                 series={series} tooltipType={tooltipType}
                                 yAxis={LABELLED_AXIS}/>
            </div>
        </div>
    )
}
